<template>
  <div style="position: relative" class="lg-maps">
    <div class="overlay-body" @click="closeModal()"></div>
    <Popup />
    <PopupValidation />
    <ThankYou />
    <PopupCountry />
    <div>
      <Hero :content="content.hero" />
      <div class="winner-overlay">
        <img src="/ru/lg-travel/images/desktop/winner/winner.png" v-if="windowWidth > 1440">
        <img src="/ru/lg-travel/images/desktop/winner/winner1.png" v-if="windowWidth > 768 && windowWidth < 1439">
        <img src="/ru/lg-travel/images/desktop/winner/winner2.png" v-if="windowWidth >= 320 && windowWidth < 767">
      </div>
      <Map  :content="content" />
      <div class="footer__lower">
        <div class="footer__lower__wrapper">
          <div class="footer__lower__text">Copyright © 2009-2021 LG Electronics. Все права защищены.</div>
          <div class="footer__lower__text">*Программа лояльности официального магазина LG: <a target="_blank" href="https://rushop.lg.com/blogs/hot_offers/1020661">https://rushop.lg.com/blogs/hot_offers/1020661</a></div>
          <div class="footer__lower__text">Официальный магазин LG:  <a target="_blank" href="https://rushop.lg.com/">https://rushop.lg.com/</a></div>
          <div class="footer__lower__text">Организатор Программы лояльности официального магазина LG: ООО «Лаборатория инноваций» ОГРН 1187746551123</div>
          <div class="footer__lower__text">Анкета для регистрации в Программе лояльности официального магазина LG: <a target="_blank" href="https://rushop.lg.com/client_account/contacts/new">https://rushop.lg.com/client_account/contacts/new</a></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ThankYou from "../components/elements/popup-thank-you/ThankYou";
import PopupValidation from "../components/elements/popup-validation/PopupValidation";
import Popup from "../components/elements/popup/Popup";
import Map from "../components/map/Map";
import Hero from "../components/hero/Hero";
import * as content from "../content/content.json";
import {bus} from "../utils/bus";
import PopupCountry from "../components/elements/popup-country/PopupCountry";

export default {
  name: "Main",
  components: {
    PopupCountry,
    ThankYou,
    PopupValidation,
    Popup,
    Map,
    Hero
  },
  data(){
    return{
      content: content.default
    }
  },
  methods: {
    closeModal(){
      bus.$emit('close-modal',false)
      bus.$emit('close-modal-valid',false)
      bus.$emit('thank-close-modal',false)
    }
  },
  mounted() {
    if(!this.$browserDetect.isIE) {
      if (window.innerWidth < 1450 && window.innerWidth > 1200) {
        document.querySelector('.lg-maps').style.zoom = "80%";
      }
      window.addEventListener('resize', function () {
        if (window.innerWidth < 1450 && window.innerWidth > 1200) {
          document.querySelector('.lg-maps').style.zoom = "80%";
        } else {
          document.querySelector('.lg-maps').style.zoom = "100%";
        }
      }, true);
    }
    // this.$getLocation()
    //     .then(coordinates => {
    //       console.log(coordinates)
    //       this.$store.commit('SET_USER_LOCATION',coordinates)
    //       this.$store.dispatch('getUserLocation').then(()=>{
    //         this.$store.dispatch('getDistance','Греция')
    //       })
    //     }).catch((e)=>{
    //   bus.$emit('open-modal-valid', "Разрешите сервису использовать данные о вашем местоположении")
    //   return e
    // });
    this.$store.commit('SET_USER_LOCATION',{
      lat: 55.5807481,
      lng: 36.8251284
    })
    this.$store.dispatch('getUserLocation').then(()=>{
      this.$store.dispatch('getDistance','Греция')
    }).catch((e)=>console.log(e))
    if (window.location.search.includes('?success')) {
      const urlParams = new URLSearchParams(window.location.search);
      const myParam = urlParams.get('success');
      this.$store.commit('SET_EMAIL',myParam)
      bus.$emit('country-open-modal' +
          '' +
          '', true)
    }
  },
  computed: {
    windowWidth() {
      return window.innerWidth
    }
  }
}
</script>

<style scoped>

</style>